import React from "react";
import styled from "styled-components";
import { ImgWrap } from "../../styles/Common";
import noHistoryImg from "../../styles/images/img_nohistory.png";

const NoHistory = (props) => {
  return (
    <NoHistoryWrap>
      <p>조회된 내역이 없습니다.</p>
      <ImgWrap imgwidth="14.2" margintop="2">
        <img src={noHistoryImg} alt="" />
      </ImgWrap>
    </NoHistoryWrap>
  );
};

export default NoHistory;
const NoHistoryWrap = styled.div`
  padding-top: 7rem;
  p {
    text-align: center;
    font-size: 1.4rem;
    line-height: 1.4rem;
    color: ${({ theme }) => theme.color.input_text_gray_light};
  }
`;
